import React, { useState } from "react";
import { Box, Divider, Tab, Tabs } from "@mui/material";

import { TabLabel } from "./components";
import { CarriersProvider } from "./contexts/carriersContext";
import { MOCK_STATS } from "./mock";
import {
  CarriersRepDirectoryHeader,
  DataQualityTab,
  DirectoryTab,
} from "./sections";

type RepDirectoryTab = "directory" | "data-quality";

export const CarriersRepDirectory = (): React.JSX.Element => {
  const [activeTab, setActiveTab] = useState<RepDirectoryTab>("directory");

  return (
    <Box display="flex" flexDirection="column" flex={1} minHeight={0}>
      <CarriersRepDirectoryHeader stats={MOCK_STATS} />
      <Tabs
        value={activeTab}
        onChange={(_, value: RepDirectoryTab) => setActiveTab(value)}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="Carrier rep directory tabs"
      >
        <Tab label="Directory" value="directory" />
        <Tab
          label={
            <TabLabel label="Data quality" count={MOCK_STATS.needsReview} />
          }
          value="data-quality"
        />
      </Tabs>
      <Divider />

      <Box pt={2} flex={1} minHeight={0}>
        {activeTab === "directory" && (
          <CarriersProvider>
            <DirectoryTab />
          </CarriersProvider>
        )}
        {activeTab === "data-quality" && <DataQualityTab />}
      </Box>
    </Box>
  );
};
